import type { ReactNode } from 'react';

import { GoldllenLogo } from '../brand';
import { DesktopNavbar } from './desktop-navbar';
import * as styles from './index.css';
import { MobileNavbar } from './mobile-navbar';

export const AffineOtherPageLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <div className={styles.root}>
      {BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : (
        <div className={styles.topNav}>
          <a
            href={environment.subPath || '/'}
            aria-label="Goldllen — página inicial"
            className={styles.affineLogo}
          >
            <GoldllenLogo width={144} height={36} />
          </a>

          <DesktopNavbar />
          <MobileNavbar />
        </div>
      )}

      {children}
    </div>
  );
};
